
interface Measurements {
  height: string;
  width: string;
  depth: string;
  strap?: string;
}

interface BagMeasurementsProps {
  measurements: Measurements;
}

export const BagMeasurements = ({ measurements }: BagMeasurementsProps) => {
  return (
    <div className="pt-12 grid grid-cols-2 gap-4 sm:grid-cols-5">
      <div>
        <p className="text-sm text-muted-foreground">Height</p>
        <p className="font-medium">{measurements.height}</p>
      </div>
      <div>
        <p className="text-sm text-muted-foreground">Width</p>
        <p className="font-medium">{measurements.width}</p>
      </div>
      <div>
        <p className="text-sm text-muted-foreground">Depth</p>
        <p className="font-medium">{measurements.depth}</p>
      </div>
      {measurements.strap && (
        <div>
          <p className="text-sm text-muted-foreground">Strap Drop</p>
          <p className="font-medium">{measurements.strap}</p>
        </div>
      )}
    </div>
  );
};

